/**
 * Frontend mirror of backend support enums.
 * Keep aligned with InviteCloudBackend/src/support/constants.ts.
 */
import type {
  AdminFaqCategory,
  AdminSupportTicketCategory,
  AdminSupportTicketPriority,
  AdminSupportTicketStatus,
} from '@/src/infrastructure/lib/api';

export const SUPPORT_STATUSES: AdminSupportTicketStatus[] = [
  'OPEN',
  'IN_PROGRESS',
  'WAITING_FOR_USER',
  'RESOLVED',
  'CLOSED',
];

export const SUPPORT_PRIORITIES: AdminSupportTicketPriority[] = [
  'LOW',
  'MEDIUM',
  'HIGH',
  'URGENT',
];

export const SUPPORT_CATEGORIES: AdminSupportTicketCategory[] = [
  'ACCOUNT',
  'BILLING',
  'TEMPLATE',
  'INVITATION',
  'PUBLISHING',
  'RSVP',
  'MEDIA',
  'BUG',
  'FEATURE_REQUEST',
  'OTHER',
];

export const STATUS_LABEL: Record<AdminSupportTicketStatus, string> = {
  OPEN: 'Open',
  IN_PROGRESS: 'In progress',
  WAITING_FOR_USER: 'Awaiting user',
  RESOLVED: 'Resolved',
  CLOSED: 'Closed',
};

export const STATUS_TONE: Record<AdminSupportTicketStatus, string> = {
  OPEN: 'bg-amber-500/15 text-amber-700 border-amber-500/30',
  IN_PROGRESS: 'bg-sky-500/15 text-sky-700 border-sky-500/30',
  WAITING_FOR_USER: 'bg-violet-500/15 text-violet-700 border-violet-500/30',
  RESOLVED: 'bg-emerald-500/15 text-emerald-700 border-emerald-500/30',
  CLOSED: 'bg-zinc-500/15 text-zinc-700 border-zinc-500/30',
};

export const PRIORITY_TONE: Record<AdminSupportTicketPriority, string> = {
  LOW: 'text-zinc-500',
  MEDIUM: 'text-sky-600',
  HIGH: 'text-amber-600',
  URGENT: 'text-rose-600',
};

export const FAQ_CATEGORY_LABEL: Record<AdminFaqCategory, string> = {
  GETTING_STARTED: 'Getting started',
  TEMPLATES: 'Templates',
  INVITATIONS: 'Invitations',
  RSVP: 'RSVP',
  BILLING: 'Billing & plans',
  ACCOUNT: 'Account',
  TROUBLESHOOTING: 'Troubleshooting',
  OTHER: 'Other',
};

export const FAQ_CATEGORIES = Object.keys(FAQ_CATEGORY_LABEL) as AdminFaqCategory[];
